module.exports = __webpack_public_path__ + "img/overview.27af87e8.svg";